import React from 'react';
import { Brain, Layout, Shield, BarChart3 } from 'lucide-react';
import { capabilities } from '../data/mock';

const iconMap = {
  Brain: Brain,
  Layout: Layout,
  Shield: Shield,
  BarChart3: BarChart3,
};

const CapabilitiesSection = () => {
  return (
    <section id="capabilities" className="py-24 md:py-32 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="inline-block text-cyan-400 text-sm font-semibold tracking-wider uppercase mb-4">
            Our Capabilities
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            What We Build
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            Enterprise-grade platforms and frameworks designed with technology-first principles and compliance at their core.
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {capabilities.map((capability, index) => {
            const Icon = iconMap[capability.icon];
            return (
              <div
                key={capability.id}
                className="group relative bg-gradient-to-b from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-2xl p-6 hover:border-cyan-500/30 transition-all duration-500 hover:-translate-y-1"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Number Badge */}
                <div className="absolute top-4 right-4 text-4xl font-bold text-slate-800 group-hover:text-slate-700 transition-colors">
                  0{capability.id}
                </div>

                {/* Icon */}
                <div className="relative z-10 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-cyan-500/10 text-cyan-400 mb-5 group-hover:bg-cyan-500/20 transition-all duration-300">
                  <Icon size={24} />
                </div>

                {/* Content */}
                <h3 className="relative z-10 text-lg font-semibold text-white mb-3 group-hover:text-cyan-50 transition-colors">
                  {capability.title}
                </h3>
                <p className="relative z-10 text-sm text-slate-400 leading-relaxed">
                  {capability.description}
                </p>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;
